import { Paper, responsiveFontSizes } from '@material-ui/core';
import { useStyles } from '@webapps/styles';
import { resolvePath } from '@webapps/utils';
import PropTypes from 'prop-types';

import Autocomplete from '../components/Autocomplete';
import FormikTextField from './FormikTextField50';

const FormikAutocomplete = ({
  defaultValue = false,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  formik: { handleChange: formikHandleChange, ...formik },
  label,
  multiple,
  name,
  pathValue,
  endAdornment,
  disalabled,
  ...props
}) => {
  const { setFieldValue, values } = formik;

  const {
    theme: { fontSizes },
  } = useStyles();

  const handleChange = (_, value) => {
    if (pathValue) {
      if (multiple) {
        setFieldValue(
          name,
          value.reduce(
            (acc, cur) => [...acc, resolvePath(cur, pathValue, defaultValue)],
            []
          ),
          true
        );
      } else {
        setFieldValue(name, resolvePath(value, pathValue, defaultValue), true);
      }
    } else {
      setFieldValue(name, value, true);
    }
  };

  return (
    <Autocomplete
      multiple={multiple}
      onChange={handleChange}
      PaperComponent={({ children }) =>
        <Paper style={{ '@media only screen and (max-width:1920px)': {fontSize: '13.500px'}, '@media only screen and (max-width:1600px)': {fontSize: '13.5000px'}, }}>{children}</Paper>
      }
      renderInput={(params) => {
        if (endAdornment) params.InputProps.endAdornment = endAdornment
        return <FormikTextField
          formik={formik}
          label={label}
          name={name}
          {...params}
          variant='filled'
        />
      }}
      value={resolvePath(values, name, defaultValue)}
      {...props}
    />
  );
};

FormikAutocomplete.propTypes = {
  name: PropTypes.string,
  label: PropTypes.node,
  formik: PropTypes.object,
  pathValue: PropTypes.string,
  defaultValue: PropTypes.any,
  multiple: PropTypes.bool,
};

export default FormikAutocomplete;
